import { useTranslation } from "react-i18next";
import { Route, Routes, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  VolumeUpIcon,
  CollectionIcon,
  IdentificationIcon,
  UserGroupIcon,
  CalendarIcon,
  DocumentTextIcon,
} from "@heroicons/react/outline";
import Sidebar from "../../components/Layouts/Sidebar";
import SideHeader from "../../components/sidebar/SideHeader";
import SideFooter from "../../components/sidebar/SideFooter";
import { getLiaisonsGlobal } from "../../api/endpoints/liaisons/statistics";
import { useAuth } from "../../context/AuthContext";

function LiaisonDashboard() {
  const Context = useAuth();
  const navigate = useNavigate();
  const [unscheduledReadersCount, setUnscheduledReadersCount] = useState(0);
  const [langModal, setLangModal] = useState(false);

  const { t, i18n } = useTranslation("", {
    keyPrefix: "page.liaison.dashboard.nav",
  });
  const LiaisonLocal = useTranslation("", {
    keyPrefix: "page.liaison.dashboard",
  });

  const getLiaisonUnscheduledReaders = async () => {
    const response: any = await getLiaisonsGlobal();
    setUnscheduledReadersCount(response.data.unscheduled_students_count);
  };
  useEffect(() => {
    getLiaisonUnscheduledReaders();
  }, []);
  const navigation = [
    {
      name: t("tracking"),
      href: "/liaison/dashboard/readers",
      icon: UserGroupIcon,
      counter: unscheduledReadersCount,
      separate: "bottom",
    },
    {
      name: t("candidateRequests"),
      href: "/liaison/dashboard/candidates",
      icon: DocumentTextIcon,
      // counter: 2,
    },
    {
      name: t("personalData"),
      href: "/liaison/dashboard/personal-data",
      icon: IdentificationIcon,
    },
  ];

  const userImg = Context?.currentUser?.profile_picture_url;

  const feminizationLetter =
    i18n.language === "ar" && Context?.currentUser?.gender === "female"
      ? "ة"
      : "";

  return (
    <div className="">
      <div className="">
        <Sidebar
          img={userImg}
          navigation={navigation}
          sideHeader={
            <SideHeader
              actionName=""
              action={() => {}}
              name={Context?.currentUser?.fullNameWithoutMiddle || ""}
              usertype={`${t("liaison")}${feminizationLetter}`}
              img={userImg}
            />
          }
          sideFooter={
            <SideFooter langModal={langModal} setLangModal={setLangModal} />
          }
        ></Sidebar>
      </div>
    </div>
  );
}
export default LiaisonDashboard;
